<div #navmenu fxLayout="column" fxLayoutAlign="start stretch">
    <ng-container *ngFor="let item of FilteredItems">
        <button type="button" mat-stroked-button disableRipple [attr.id]="'NavBtn_' + item.ButtonIndex" [color]="item.Active ? 'primary' : null" [disabled]="item.Disabled" (click)="HandleItemClick(item)">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon *ngIf="item.MenuIcon">{{item.MenuIcon}}</mat-icon>
                    <span>{{item.MenuText}}</span>
                </div>
                <mat-icon *ngIf="item.Submenus && !!item.Submenus.length" [@iconspinner]="item.IsExpanded">chevron_right</mat-icon>
            </div>
        </button>
        <div *ngIf="item.Submenus && !!item.Submenus.length && item.IsExpanded" [@submenuexpand] class="submenu" fxLayout="column" fxLayoutAlign="start stretch">
            <ng-container *ngFor="let subitem of item.Submenus">
                <button type="button" mat-button disableRipple [attr.id]="'NavBtn_' + subitem.ButtonIndex" [color]="subitem.Active ? 'primary' : null" [disabled]="subitem.Disabled" (click)="HandleItemClick(subitem)">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>
                            <mat-icon *ngIf="subitem.MenuIcon">{{subitem.MenuIcon}}</mat-icon>
                            <span>{{subitem.MenuText}}</span>
                        </div>
                    </div>
                </button>
            </ng-container>
        </div>
    </ng-container>
</div>